import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "share-page-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "verify-form-wrapper"
};
import { useDasShareLayout } from '@/views/das-share/useDasShareLayout';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
import { useRoute } from 'vue-router';
import { computed, reactive, watch, unref } from 'vue';
export default {
  __name: 'share-option',
  setup(__props) {
    const {
      runAsync: getShareOptionApi
    } = fetchApi('das.utableShare.shareOption');
    const route = useRoute();
    const dasShareLayout = useDasShareLayout();
    const {
      runAsync: getShareTableDataApi,
      loading: loading1
    } = fetchApi('das.utableShare.getShareTableData', {
      showError: false
    });
    const {
      runAsync: getShareTableFormApi,
      loading: loading2
    } = fetchApi('das.utableShare.getShareTableForm', {
      showError: false
    });
    const loading = computed(() => {
      return loading1.value || loading2.value;
    });
    const state = reactive({
      error: '',
      loaded: false,
      verifyPwdState: 0,
      // 0:未验证密码，1：验证成功,2:验证失败
      dataLoaded: false,
      data: null,
      // 获取到的数据
      dataLoader: () => {}
    });
    const formData = reactive({
      password: ''
    });
    const formRules = reactive({
      password: [{
        required: true,
        message: '密码不能为空'
      }, {
        min: 4,
        max: 8,
        message: '密码长度在4-8位之间'
      }]
    });
    const shareOption = reactive({
      linkId: '',
      mode: '',
      // report|form
      verifyPwd: false,
      orgId: '',
      orgName: '',
      userId: '',
      username: '',
      expired: '',
      isExpired: false,
      tableId: 0
    });
    const getShareOption = async linkId => {
      state.error = '';
      state.loaded = false;
      const {
        error,
        ...res
      } = await getShareOptionApi({
        linkId
      });
      if (error) {
        state.error = error;
        return false;
      }
      Object.assign(shareOption, res);
      state.loaded = true;
    };
    const getShareTableData = async ({
      currentPage,
      pageSize
    }) => {
      const {
        error,
        ...res
      } = await getShareTableDataApi({
        linkId: shareOption.linkId,
        password: formData.password,
        pi: currentPage || 1,
        ps: pageSize || 20
      });
      if (error) return {
        error
      };
      return res;
    };
    const getShareTableForm = async () => {
      const {
        error,
        ...res
      } = await getShareTableFormApi({
        linkId: shareOption.linkId,
        password: formData.password
      });
      if (error) return {
        error
      };
      return res;
    };
    const handleRetry = () => {
      state.error = '';
      state.dataLoaded = false;
    };
    const handleVerifySubmit = () => {
      return doVisit();
    };
    const doVisit = async () => {
      state.dataLoaded = false;
      state.error = '';
      if (shareOption.mode === 'report') {
        const {
          error,
          ...res
        } = await getShareTableData({});
        if (error) {
          state.error = error;
          state.dataLoaded = true;
          return false;
        }
        state.dataLoader = getShareTableData;
        state.data = res || {};
        state.dataLoaded = true;
        return true;
      } else if (shareOption.mode === 'form') {
        const {
          error,
          ...res
        } = await getShareTableForm();
        if (error) {
          state.error = error;
          state.dataLoaded = true;
          return false;
        }
        state.dataLoader = getShareTableForm;
        state.dataLoaded = true;
        state.data = res || {};
        return true;
      }
      return false;
    };
    watch(() => shareOption, val => {
      const {
        orgName = '',
        username = ''
      } = val || {};
      if (orgName || username) {
        if (orgName) {
          dasShareLayout.setState({
            username: `${orgName}——${username}`
          });
        } else {
          dasShareLayout.setState({
            username: `${username}`
          });
        }
      }
    }, {
      deep: true
    });
    watch(() => state.loaded, val => {
      if (unref(val) && !shareOption.verifyPwd) {
        // 不需要密码验证时，直接打开
        doVisit();
      }
    });
    watch(() => [route.query, route.params], val => {
      const [v1, v2] = val;
      const {
        linkId: linkId1 = ''
      } = v1 || {};
      const {
        linkId: linkId2 = ''
      } = v2 || {};
      const linkId = linkId1 || linkId2;
      if (linkId) {
        getShareOption(linkId);
      } else {
        state.error = '链接地址无效';
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_result = _resolveComponent("vxe-result");
      const _component_vxe_password_input = _resolveComponent("vxe-password-input");
      const _component_vxe_form_item = _resolveComponent("vxe-form-item");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      const _component_vxe_form = _resolveComponent("vxe-form");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(state).error ? (_openBlock(), _createBlock(_component_vxe_result, {
        key: 0,
        icon: "vxe-icon-error-circle",
        status: "error",
        title: "出错了",
        content: _unref(state).error
      }, {
        extra: _withCtx(() => [_createVNode(_component_vxe_button, {
          onClick: handleRetry
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("重试", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["content"])) : _createCommentVNode("", true), _unref(state).loaded && _unref(shareOption).isExpired ? (_openBlock(), _createBlock(_component_vxe_result, {
        key: 1,
        icon: "vxe-icon-warning-triangle",
        status: "error",
        title: "提示",
        content: "您访问的内容已过期了"
      })) : _createCommentVNode("", true), _unref(state).loaded && !_unref(shareOption).isExpired ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [!_unref(state).dataLoaded && _unref(shareOption).verifyPwd && _unref(state).verifyPwdState === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_vxe_form, {
        data: _unref(formData),
        rules: _unref(formRules),
        loading: _unref(loading),
        "title-align": "right",
        "title-colon": "",
        "title-width": "120",
        onSubmit: handleVerifySubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_form_item, {
          span: "12",
          field: "password",
          title: "访问密码"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_password_input, {
            modelValue: _unref(formData).password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).password = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_button_group, null, {
            default: _withCtx(() => [_createVNode(_component_vxe_button, {
              type: "submit",
              status: "primary"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("访问", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "rules", "loading"])])) : _createCommentVNode("", true), !_unref(state).error && _unref(state).dataLoaded ? (_openBlock(), _createBlock(_component_router_view, {
        key: 1
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), _normalizeProps(_guardReactiveProps({
          share: _unref(shareOption),
          data: _unref(state).data,
          dataLoader: _unref(state).dataLoader,
          password: _unref(formData).password
        })), null, 16))]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
    };
  }
};